<template>
  <div ref="selector" :class="{ 'date-selector': true, 'date-selector--grid': true, 'date-selector--selected': activeTitle }">
    <Accordion ref="accordion" @show="onSelectorOpen" :title="activeTitle ? activeTitle : context.attrs.placeholder">
      <template #content>
        <div class="date-selector--grid--date">
          <VueDatePicker v-model="data.date" :locale="locale" class="date-picker" inline auto-apply week-start="1" :min-date="min" :enable-time-picker="false" :enable-month-picker="false" focus-start-date :start-date="min" hide-offset-dates month-name-format="long" :month-change-on-scroll="false" @update-month-year="onMonthYearChange" @update:model-value="onDateChange">
            <template #arrow-left>
              <div class="slot-icon slot-icon__left" />
            </template>
            <template #arrow-right>
              <div class="slot-icon slot-icon__right" />
            </template>
            <template #action-extra>
              <div v-if="loading" class="dateSelector-loader"><Icon :loading="true" /> Beschikbare data ophalen</div>
            </template>
          </VueDatePicker>
          <div class="date-selector__message">
            <div class="date-select__info" v-if="!tempDate" v-html="context.attrs.notice"></div>
            <div class="date-select__info" v-else-if="isDateWithin8Weeks(tempDate)" v-html="context.attrs.warning"></div>
            <div class="date-select__info" v-else-if="tempDate">{{ $t('date.confirm') }}</div>
            <button class="button button--secondary" @click.prevent="onConfirmDate" :disabled="!tempDate">{{ $t('date.proceed') }}</button>
          </div>
        </div>
      </template>
    </Accordion>
  </div>
</template>

<script src="./DateSelector.js"></script>
